import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Item from './Item';
import { getCategoryIcon } from '../Common/icon-type';
import { styled } from '@linaria/react';
const Blog = (props) => {
  const getH2Style = (isBgVideo, isAtTop, isFirstPage) => {
    const classes = [];
    if (!isBgVideo) {
      if (isAtTop) classes.push('isAtTop');
      else classes.push('isInMiddle');
      if (isFirstPage) classes.push('isFirstPage');
    }
    return classes.join(' ');
  };

  const {
    posts,
    category,
    subCategory,
    theme,
    isFocusPosts,
    isFocusLastPost,
    isAtTop,
    isBgVideo,
    isFeatured,
    isRelevantPosts,
    isFirstPage,
    totalCount,
  } = props;
  const h2Style = getH2Style(isBgVideo, isAtTop, isFirstPage);
  // Focus Post will enlarge the first item on grid layout
  const isFocusPostsClass = isFocusPosts ? 'isFocusPosts' : 'isInMiddle';
  // Focus Post for last will enlarge the last item on grid layout
  const isFocusLastPostClass = isFocusLastPost ? 'isFocusLastPost' : '';
  const itemClass = isFocusLastPost ? `${isFocusPostsClass} ${isFocusLastPostClass}` : isFocusPostsClass;
  // useEffect(() => {
  //   console.log('useEffect Blog mount', props);
  //   return () => {
  //     console.log('useEffect Blog unmount:', props);
  //   };
  // }, []);
  return (
    <React.Fragment>
      <MainStyle className={isAtTop ? 'isAtTop' : 'isInMiddle'} isFeatured={isFeatured} theme={theme}>
        <H2Container>
          <H2Style className={h2Style} theme={theme}>
            {category} {getCategoryIcon(category, true)}
            {isFocusPosts && subCategory === ''
              ? '熱門推薦'
              : isFeatured
              ? '精選旅程'
              : subCategory !== ''
              ? subCategory
              : isRelevantPosts
              ? '相關推薦'
              : ''}
          </H2Style>
          {totalCount && (
            <H2Style className={h2Style + ' total'} theme={theme}>
              共有{totalCount}篇文章
            </H2Style>
          )}
        </H2Container>
        <UnorderedList className={isFocusPosts ? 'isFocusPosts post-grid' : 'post-grid'} theme={theme}>
          {posts.map((post) => {
            let postData, slug;
            if (post.node?.fields?.slug) {
              slug = post.node.fields.slug;
            } else if (post.node.contentful_id) {
              slug = post.node.slug;
            }
            postData = post.node;
            return (
              <Item isFeatured={isFeatured} key={slug} post={postData} theme={theme} className={itemClass} />
            );
          })}
        </UnorderedList>
      </MainStyle>
    </React.Fragment>
  );
};

Blog.defaultProps = {
  subCategory: '',
  isFocusPosts: false,
  isFocusLastPost: false,
  isAtTop: false,
  isBgVideo: false,
  isFeatured: false,
  isRelevantPosts: false,
};

Blog.propTypes = {
  posts: PropTypes.array.isRequired,
  isFocusPosts: PropTypes.bool,
  isFocusLastPost: PropTypes.bool,
  isBgVideo: PropTypes.bool,
  isAtTop: PropTypes.bool,
  category: PropTypes.string,
  subCategory: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isFeatured: PropTypes.bool,
  isRelevantPosts: PropTypes.bool,
  isFirstPage: PropTypes.bool,
  totalCount: PropTypes.number,
};

export default Blog;

const MainStyle = styled.main`
  padding: 0 ${(props) => props.theme.space.inset.default};
  &::before {
    margin-top: 90px;
    border-top: 1px solid ${(props) => props.theme.line.color};
    content: '';
    height: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transition: all ${(props) => props.theme.time.duration.default};
    width: 60%;
    display: ${(props) => (props.isFeatured ? 'none' : 'inherit')};
  }

  &.isAtTop {
    &::before {
      display: none;
    }
  }

  @media (max-width: 680px) {
    &::before {
      display: none;
    }
  }

  @media (min-width: 680px) and (max-width: 980px) {
    &::before {
      width: 0%;
      left: 65%;
    }
  }

  @media (min-width: 980px) {
    &::before {
      margin-top: 90px;
      width: 0%;
      left: 60%;
    }
    &.isInMiddle {
      &::before {
        margin-top: 20px;
      }
    }
  }

  @media (min-width: 1440px) {
    &::before {
      margin-top: 90px;
      width: 63%;
      left: 65%;
    }
    &.isInMiddle {
      &::before {
        margin-top: 20px;
      }
    }
  }

  @media (min-width: 1800px) {
    &::before {
      margin-top: 90px;
      width: 65%;
    }
    &.isInMiddle {
      &::before {
        margin-top: 20px;
      }
    }
    padding: 0 calc(${(props) => props.theme.space.inset.default} * 2)};
  }
`;

const H2Container = styled.div`
  display: flex;
  @media (max-width: 680px) {
    flex-flow: column;
  }
`;

const H2Style = styled.h2`
  padding: 30px ${(props) => props.theme.space.s} 0;
  line-height: ${(props) => props.theme.blog.h1.lineHeight};
  font-size: ${(props) => props.theme.blog.h1.size};
  &::before {
    display: table;
    content: '';
    margin-bottom: -0.17em;
  }
  &::after {
    display: table;
    content: '';
    margin-top: -0.11em;
  }

  .arrow {
    position: relative;
    top: 4px;
    margin-right: 5px;
    margin-left: 5px;
  }

  &.isInMiddle {
    padding: 10px ${(props) => props.theme.space.s} 0;
  }

  &.isFirstPage {
    padding: 20px ${(props) => props.theme.space.s} 0;
    margin-top: 0px;
  }

  @media (min-width: 980px) {
    &.isAtTop {
      margin-top: 50px;
    }
    &.isFirstPage {
      padding: 20px ${(props) => props.theme.space.s} 0;
      margin-top: 0px;
    }
  }

  @media (min-width: 1440px) {
    &.isAtTop {
      margin-top: 50px;
    }
    &.isFirstPage {
      padding: 20px ${(props) => props.theme.space.s} 0;
      margin-top: 0px;
    }
  }

  @media (min-width: 1800px) {
    &.isAtTop {
      margin-top: 50px;
    }
    &.isFirstPage {
      padding: 20px ${(props) => props.theme.space.s} 0;
      margin-top: 0px;
    }
  }

  @media (max-width: 680px) {
    &.total {
      padding-top: 10px;
      font-size: ${(props) => props.theme.font.size.sm};
    }
  }
`;

const UnorderedList = styled.ul`
  list-style: none;
  margin: 0 auto;

  &.post-grid {
    display: grid;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  @media (max-width: 680px) {
    &.post-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (min-width: 680px) and (max-width: 980px) {
    &.post-grid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (min-width: 980px) {
    &.post-grid {
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 30px;
    }

    &.isFocusPosts.post-grid {
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 30px;
    }
  }
`;
